import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Mail, Github, Linkedin } from 'lucide-react';
import Layout from '../components/Layout';
import ThemeToggle from '../components/ThemeToggle';

function Home() {
  return (
    <Layout maxWidth="max-w-lg" className="p-4 flex items-center justify-center min-h-screen bg-primary-light dark:bg-primary-dark" noPadding>
      <div className="flex flex-col items-center">
        {/* Theme Toggle */}
        <div className="absolute top-4 right-4">
          <ThemeToggle />
        </div>

        {/* Profile Image */}
        <div className="w-32 h-32 rounded-full overflow-hidden mb-6 ring-2 ring-gray-200 dark:ring-gray-700">
          <img
            src="/github_head.jpg"
            alt="Shenqian Wen"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Name */}
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Shenqian Wen</h1>

        {/* Title */}
        <p className="text-lg text-gray-600 dark:text-gray-300 mb-2">
          Computer Science Graduate Student
        </p>

        {/* Location */}
        <p className="text-gray-500 dark:text-gray-400 mb-6">
          Northeastern University, Seattle
        </p>

        {/* Social Links */}
        <div className="flex space-x-6 mb-8">
          <a
            href="../public/SDE_intern_ShenqianWen-v2.0.pdf"
            className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors flex items-center gap-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FileText size={20} />
            <span className="text-sm">Resume</span>
          </a>
          <a
            href="mailto:shqiwen@gmail.com"
            className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors flex items-center gap-2"
          >
            <Mail size={20} />
            <span className="text-sm">Email</span>
          </a>
          <a
            href="https://github.com/ShqiW"
            className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors flex items-center gap-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Github size={20} />
            <span className="text-sm">GitHub</span>
          </a>
          <a
            href="https://linkedin.com/in/shenqian-wen"
            className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors flex items-center gap-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Linkedin size={20} />
            <span className="text-sm">LinkedIn</span>
          </a>
        </div>

        {/* Navigation */}
        <nav className="flex flex-wrap justify-center gap-3">
          <Link
            to="/about"
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-800 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            About Me
          </Link>
          <Link
            to="/projects"
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-800 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            Projects
          </Link>
          <Link
            to="/fun"
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-800 rounded-md hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
          >
            Fun
          </Link>
       
          {/* <Link
            to="/tags"
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
          >
            Tags
          </Link>*/}
          {/* <Link
            to="/notes"
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
          >
            Notes
          </Link> */}
        </nav>

        {/* Brief Bio */}
        {/* <p className="mt-8 text-center text-gray-600 max-w-md">
          Focusing on software development and natural language processing,
          with research interests in Portuguese irregular verbs and computational linguistics.
        </p> */}
      </div>
    </Layout>
  );
}

export default Home;